import { FC } from 'react';
import styled from 'styled-components';

import { MEDIA_QUERIES } from '#/hooks/useResponsiveValue';
import { BreakpointKeys } from '#/service/constants';
import { remify } from '#/service/utils';

const DividerLine = styled.div`
  width: 2px;
  height: 100%;
  min-height: ${remify(200)};
  background: var(--pageParagraphForeground);

  @media ${MEDIA_QUERIES[BreakpointKeys.SM]} {
    width: 100%;
    height: 1px;
    min-height: 1px;
  }
`;

export const GroupDivider: FC = () => {
  return <DividerLine />;
};
